<template>
  <div v-bind:class="{
    'row': true,
    'post': true,
    'self': parseInt(post.is_self_post),
    'origin': parseInt(post.is_origin_post),
    'has-reply': post.reply,
    'suggestion': (post.type === 'suggestion'),
    'comment': (post.type === 'comment'),
    'question': (post.type === 'question'),
    'locked': isComicLocked
  }">
    <div
      v-if="post.type === 'suggestion'"
      v-bind:class="{
        'cell': true,
        'cell-vote': true,
        'cell-vote-up': parseInt(post.user_vote)
      }"
      @click="postVote"
    >
      {{post.votes}}
      <span class="star">
        {{parseInt(post.user_vote) ? '&#9733;' : '&star;'}}
      </span>
    </div>
    <div class="cell cell-username">
      {{post.username}}
      <span
        v-if="
          (parseInt(post.is_self_post) && canDelete && !isComicLocked) ||
          (this.$store.state.user && this.$store.state.user.is_admin)
        "
      >
        (<a class="cell-delete" @click="deletePost">delete</a>)
      </span>
    </div>
    <div
      class="twelve columns"
      v-if="postError"
    ><p>{{postError}}</p></div>
    <div class="twelve columns">
      <div class="cell cell-text">
        {{post.text}}
      </div>
    </div>
    <div v-if="post.reply" class="row reply">
      <div class="twelve columns">
        <div class="cell cell-username">Reply</div>
      </div>
      <div class="twelve columns">
        <div
          class="cell cell-text"
          v-html="post.reply"
        ></div>
      </div>
    </div>
    <div
      v-if="
        post.type !== 'suggestion' &&
        (this.$store.state.user && this.$store.state.user.is_admin)
      "
    >
      <textarea
        class="edit-reply u-full-width"
        v-model="post.reply"
      ></textarea>
      <button
        class="button"
        @click="editReply"
      >Edit</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

let timeout = null

export default {
  props: ['post'],
  data () {
    return {
      postError: '',
      canDelete: false
    }
  },
  computed: {
    isComicLocked () {
      return this.$store.state.comicData.comic.is_locked
    }
  },
  methods: {
    postVote () {
      if (parseInt(this.post.is_origin_post) || this.isComicLocked) {
        return
      }
      return this.$store.dispatch('postVote', this.post.pk_post_id).then(
        () => {},
        (err) => {
          this.postError = err
        }
      )
    },
    refresh () {
      const created = moment(this.post.created_time)
      const fiveMinsAgo = moment().subtract(5, 'm') // DEBUG
      this.canDelete = created.isAfter(fiveMinsAgo)
    },
    deletePost () {
      const isAdmin = this.$store.state.user && this.$store.state.user.is_admin
      if (this.isComicLocked && !isAdmin) {
        return
      }
      if (!confirm('Really Delete Post?')) {
        return
      }
      this.$store.dispatch('deletePost', this.post.pk_post_id).then(
        () => {},
        (err) => {
          this.postError = err
        }
      )
    },
    editReply () {
      this.$http.post(process.env.API_URL + '/admin/editreply.php', {
        postId: this.post.pk_post_id,
        reply: this.post.reply
      }).then(res => {
        if (res.body.status === 'success') {
          this.postError = 'Saved Reply'
        } else {
          this.postError = res.body.data
        }
      })
    }
  },
  created () {
    this.refresh()
    timeout = window.setInterval(this.refresh.bind(this), 1000)
  },
  destroyed () {
    window.clearTimeout(timeout)
  }
}
</script>

<style scoped>
.post {
  background-color: #aaa;
  margin-top: 2rem;
  margin-bottom: 2rem;
  border-left-style: solid;
  border-left-width: 2rem;
  padding: 2rem;
}

.suggestion {
  border-left-color: #B61D31;
}

.question {
  border-left-color: #4A838C;
}

.comment {
  border-left-color: #618B29;
}

.reply {
  margin-left: 4rem;
  border-left-color: #5E2550;
}

.cell-username {
  font-family: "Unica One";
  font-weight: bold;
  text-transform: uppercase;
}

.star {
  margin-left: 5px;
}

.cell-vote {
  float: left;
  margin-right: 2%;
  cursor: pointer;
  transition: color 300ms ease-out;
}

.cell-vote:hover {
  color: #ddffdd;
}

.locked .cell-vote {
  cursor: no-drop;
}

.locked .cell-vote:hover {
  color: #222;
}

.origin .cell-vote {
  color: yellow;
  cursor: default;
}

.cell-vote-up {
  color: #ddffdd;
}

.locked .cell-vote-up:hover {
  color: #ddffdd;
}

.cell-delete {
  cursor: pointer;
  color: white;
  transition: color 300ms ease-out;
}

.cell-delete:hover {
  color: #ccc;
}

.cell-text {
  white-space: pre-line;
}

</style>



// WEBPACK FOOTER //
// Post.vue?9a8a6a8e